import React, { useState } from 'react';
import { Tabs, Tab, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import LoanOfficerPresenter from 'presenters/LoanOfficerPresenter';
import BidPresenter from 'presenters/BidPresenter';
import { isBlank } from 'utils/helperMethods';
import LoanOfficerInfoBar from 'sharedComponents/LoanOfficerInfoBar';
import LoanTermsInfo from 'sharedComponents/LoanTermsInfo';

import useStyles from './useStyles';

const LoanOfficerBar = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { bid, loanOfficer } = props;
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabChange = (_event, newValue) => {
    setActiveTabIndex(newValue);
  };

  const showLoanOfficerInfo = activeTabIndex === 0 && !isBlank(loanOfficer);
  const showLoanOfficerPlaceHolder = activeTabIndex === 0 && isBlank(loanOfficer);
  const showBidInfo = activeTabIndex === 1 && !isBlank(bid);
  const showBidPlaceHolder = activeTabIndex === 1 && isBlank(bid);

  return (
    <div className={classes.container}>
      <Tabs
        value={activeTabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabs}
      >
        <Tab label={t('components.LoanOfficerBar.officersInfo')} value={0} className={classes.tab} />
        <Tab label={t('components.LoanOfficerBar.loanTerms')} value={1} className={classes.tab} />
      </Tabs>
      <div className={classes.content}>
        {showLoanOfficerInfo && <LoanOfficerInfoBar loanOfficer={loanOfficer} />}
        {showLoanOfficerPlaceHolder && (
          <Typography variant="subtitle1" color="secondary">
            {t('components.LoanOfficerBar.LoanOfficerBlank')}
          </Typography>
        )}
        {showBidInfo && <LoanTermsInfo bid={bid} />}
        {showBidPlaceHolder && (
          <Typography variant="subtitle1" color="secondary">
            {t('components.LoanOfficerBar.bidIsBlank')}
          </Typography>
        )}
      </div>
    </div>
  );
};

LoanOfficerBar.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape(),
  bid: BidPresenter.shape(),
};

LoanOfficerBar.defaultProps = {
  loanOfficer: {},
  bid: {},
};

export default LoanOfficerBar;



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/DesktopMessages/components/LoanOfficerBar/LoanOfficerBar.js